export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 6.6C21 5.60589 20.1046 4.8 19 4.8H18V3H16V4.8H8V3H6V4.8H5C3.89543 4.8 3 5.60589 3 6.6V19.2C3 20.19 3.89 21 5 21H19C20.1046 21 21 20.1941 21 19.2V6.6ZM9.00001 12.9003V11.1003H7.00001V12.9003H9.00001ZM13 12.9003V11.1003H11V12.9003H13ZM17.0001 11.1003V12.9003H15.0001V11.1003H17.0001ZM19 19.2001V9.30014H4.99997V19.2001H19ZM9.00001 16.4999V14.6999H7.00001V16.4999H9.00001ZM13 14.6999V16.4999H11V14.6999H13ZM17.0001 16.4999V14.6999H15.0001V16.4999H17.0001Z"
      fill="currentColor"
    />
  </svg>
);
